import React from 'react';
import { CreditCardIcon, ZapIcon } from 'lucide-react';
export const TopBanner = () => {
  return <div className="relative w-full bg-gradient-to-r from-sky-500 via-blue-500 to-sky-500 text-white overflow-hidden" data-id="element-291">
      {/* Animated shine sweep */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-292">
        <div className="absolute top-0 -left-1/3 w-1/3 h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 animate-banner-shine" data-id="element-293" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-center text-sm sm:text-base font-semibold" data-id="element-294">
        <ZapIcon className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-300 fill-yellow-300 animate-pulse shrink-0" data-id="element-295" />
        <span className="tracking-wide" data-id="element-296">
          Aboná con <span className="font-extrabold" data-id="element-297">Mercado Pago</span> y en
          cuotas{' '}
          <span className="font-extrabold underline decoration-yellow-300 decoration-2 underline-offset-2" data-id="element-298">
            sin interés
          </span>
        </span>
        <CreditCardIcon className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" data-id="element-299" />
      </div>
    </div>;
};